var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M7.252 3.037a.47.47 0 0 0-.225.242c-.036.106-.036 17.336 0 17.442a.47.47 0 0 0 .225.242c.068.033.133.037.566.037s.498-.004.566-.037a.54.54 0 0 0 .221-.237c.024-.066.024-17.385 0-17.452a.54.54 0 0 0-.221-.237C8.316 3.004 8.25 3 7.818 3c-.433 0-.498.004-.566.037m7.364 0a.54.54 0 0 0-.221.237c-.024.067-.024 17.386 0 17.452.029.08.139.198.221.237.068.033.134.037.566.037.433 0 .498-.004.566-.037a.47.47 0 0 0 .225-.242c.036-.106.036-17.336 0-17.442a.47.47 0 0 0-.225-.242C15.68 3.004 15.615 3 15.182 3s-.498.004-.566.037",
    clipRule: "evenodd"
  })));
};
export default SvgPause;